import Joi from 'joi';
import type { IConfigureParams } from '../voice-to-text/configureParams';
import { configureParamsSchema } from '../voice-to-text/configureParams';
import type { SchemaOf, ExtractValues } from '../helpers';
import { objectSchemaOf } from '../helpers';

export const messageFromTag = ['hil', 'bot', 'user'] as const;
export const messageFromTagSchema = Joi.string().valid(...messageFromTag);
export type MessageFromTag = ExtractValues<typeof messageFromTag>;

export const botMessageType = ['information', 'question'] as const;
export const botMessageTypeSchema = Joi.string().valid(...botMessageType);
export type BotMessageType = ExtractValues<typeof botMessageType>;

export interface IMessage {
  messageId: string;
  conversationId: string;
  recordingId?: string;
  from: MessageFromTag;
  text: string;
  timestamp: number;
  endConversation?: boolean;
  voiceToTextParams?: IConfigureParams;
  botMessageType?: BotMessageType;
  botQuestionId?: string;
  commandId?: string;
  engine?: string;
}

export type IMessageShape = IMessage;

export const messageSchemaMap: SchemaOf<IMessage> = {
  messageId: Joi.string().required(),
  conversationId: Joi.string().required(),
  recordingId: Joi.string().optional(),
  from: messageFromTagSchema.required(),
  text: Joi.string().required(),
  timestamp: Joi.number().required(),
  endConversation: Joi.boolean().optional(),
  voiceToTextParams: configureParamsSchema.optional(),
  botMessageType: botMessageTypeSchema.optional(),
  botQuestionId: Joi.string().optional(),
  commandId: Joi.string().optional(),
  engine: Joi.string().optional(),
};

export const messageSchema = objectSchemaOf<IMessage>(messageSchemaMap);
